import React from 'react';
import { AccessibilityStyles } from '../styles/accessibility';
import { useTranslation } from 'react-i18next';
import { AccessibilityProfile } from '../../base/interfaces/headerInterface';
import { Typography } from '@material-ui/core';

/** Language Dropdown Props */
interface AccessibilityOptionsProps {
  options: ReadonlyArray<AccessibilityProfile>;
  selectedTheme: number;
  onHelpClick: () => void;
  onThemeChange(event: React.ChangeEvent<{ value: string }>): void;
}

/** Language Dropdown Component */
const StateLessAccessibilityOptions = ({
  options,
  onThemeChange,
  selectedTheme,
  onHelpClick,
}: AccessibilityOptionsProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = AccessibilityStyles();

  // Generate accessibility radio items
  const acsItems: JSX.Element[] = [];
  options &&
    options.forEach((p: AccessibilityProfile) => {
      const styleObj = {
        color: p.primary,
        backgroundColor: p.bgColor,
      };
      // Selected item or not?
      let radioClass = 'accRadio';
      if (p.id === selectedTheme) radioClass += '-selected';

      // Add special class to allow focus outline
      // if (keyboardInput) radioClass += ' keyboard-focus';

      // Profile translations
      let label = p.label;
      if (p.locId) label = t(p.locId);

      const item = (
        <li key={p.id}>
          <input
            className="accInput"
            type="radio"
            id={`${p.id}`}
            name="acc-profile"
            value={p.id}
            onChange={onThemeChange}
            tabIndex={0}
          />
          <label htmlFor={`${p.id}`} className={classes.accessibilityLabel} style={styleObj}>
            <span className="accText">{label}</span>
            <span className={radioClass}></span>
          </label>
        </li>
      );
      acsItems.push(item);
    });

  return (
    <>
      <Typography className={classes.accessibilityDefaultAnchorColor} tabIndex={0} onClick={onHelpClick}>
        {t('publicHeaderGetAccessibilityHelp')}
      </Typography>
      <ul className={classes.acessibilityList}>{acsItems}</ul>
    </>
  );
};

export const AccessibilityOptions = React.memo(StateLessAccessibilityOptions);
